import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { toEditorHtml } from '../utils/rich-text';
import { sanitizeRichText } from '../utils/rich-text-sanitize';

/**
 * Rich-text editor HTML for [innerHTML]: sanitized by our allowlist (keeping colours, sizes and alignment, which
 * Angular's sanitizer would strip) and then trusted. Legacy plain-text records keep their line breaks.
 */
@Pipe({ name: 'richText', standalone: false })
export class RichTextPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(html: string | null | undefined): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(sanitizeRichText(toEditorHtml(html)));
  }
}
